import { useState } from 'react'
import type { Cliente } from '../../db/tipos'
import type { LinhaMapeada } from '../../importacao/validacao'
import { gravarLocalEEnfileirar } from '../../sync/outbox'
import {
  clienteDaLinha, mesclarPreenchendoVazios, garantirVinculo,
} from '../../importacao/aplicarClientes'

interface Props {
  pares: Array<{ linha: LinhaMapeada; existente: Cliente }>
  representadaId: string
  aoConcluir: (resumo: { mesclados: number; criados: number; pulados: number }) => void
}

const CAMPOS_COMPARACAO = [
  ['razao_social', 'Razão social'],
  ['nome_fantasia', 'Fantasia'],
  ['cnpj_cpf', 'CNPJ/CPF'],
  ['municipio', 'Município'],
  ['bairro', 'Bairro'],
] as const

export default function MesclagemDuplicados({ pares, representadaId, aoConcluir }: Props) {
  const [indice, setIndice] = useState(0)
  const [resumo, setResumo] = useState({ mesclados: 0, criados: 0, pulados: 0 })

  const par = pares[indice]
  if (!par) {
    aoConcluir(resumo)
    return null
  }

  function avancar(novoResumo: typeof resumo) {
    if (indice + 1 >= pares.length) aoConcluir(novoResumo)
    else {
      setResumo(novoResumo)
      setIndice(indice + 1)
    }
  }

  async function mesclar() {
    const mesclado = mesclarPreenchendoVazios(par.existente, par.linha.campos)
    await gravarLocalEEnfileirar('clientes', mesclado)
    await garantirVinculo(mesclado.id, representadaId, par.linha.campos.codigo_na_representada || null)
    avancar({ ...resumo, mesclados: resumo.mesclados + 1 })
  }

  async function criarNovo() {
    const novo = clienteDaLinha(par.linha.campos, {})
    await gravarLocalEEnfileirar('clientes', novo)
    await garantirVinculo(novo.id, representadaId, par.linha.campos.codigo_na_representada || null)
    avancar({ ...resumo, criados: resumo.criados + 1 })
  }

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 space-y-3">
      <h3 className="font-medium text-slate-800">
        Possível duplicado {indice + 1} de {pares.length}
      </h3>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="font-medium text-slate-500">Na planilha</div>
        <div className="font-medium text-slate-500">Já cadastrado</div>
        {CAMPOS_COMPARACAO.map(([campo, rotulo]) => (
          <div key={campo} className="contents">
            <div className="border-t border-slate-100 py-1">
              <span className="block text-xs text-slate-400">{rotulo}</span>
              {par.linha.campos[campo] || '—'}
            </div>
            <div className="border-t border-slate-100 py-1">
              <span className="block text-xs text-slate-400">{rotulo}</span>
              {(par.existente[campo as keyof Cliente] as string | null) || '—'}
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2">
        <button onClick={() => void mesclar()} className="bg-teal-700 text-white rounded-lg py-2 text-sm">
          É o mesmo: mesclar
        </button>
        <button onClick={() => void criarNovo()} className="border border-teal-700 text-teal-700 rounded-lg py-2 text-sm">
          É outro: criar novo
        </button>
        <button
          onClick={() => avancar({ ...resumo, pulados: resumo.pulados + 1 })}
          className="border border-slate-300 text-slate-600 rounded-lg py-2 text-sm"
        >
          Pular
        </button>
      </div>
    </div>
  )
}
